export default __webpack_public_path__ + "static/media/alamo-arte-2.b19d8a7b.webp";